import styled from 'styled-components';

import { CFG } from '../../../../../../theme/configurator-tokens';
import { SPACE } from '../../../../../../theme/tokens';
import { Text } from '../../../../../../components';

export const Heading = styled(Text)`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.1;
  color: ${CFG.base50};
`;

export const Groups = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[24]};
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

/* --- Section label --------------------------------------------------------- */
export const SectionLabel = styled(Text)`
  white-space: nowrap;
  font-size: 14px;
  line-height: 1.15;
  color: ${CFG.base400};
`;

/* --- Colour swatch grid (five per row, each fills its column, square). The gap
   leaves room for the selected swatch's ring, which sits 5px outside it. ------ */
export const ColorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: ${SPACE[12]};
`;

/* --- Style tiles, three per row (the ring sits 6px outside the selected tile) - */
export const StyleList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${SPACE[12]};
`;
